import {
  Table, TableBody, TableCell, TableContainer, TableRow, Paper, Dialog, DialogTitle, DialogContent, DialogActions, Button
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

export function RaceDetailModal({ open, onClose, race, skis }) {
  const theme = useTheme();
  if (!race) return null;
  const skiMap = Object.fromEntries((skis || []).map(ski => [ski.id, ski.ski_number]));
  const detailRows = [
    { label: 'Name', value: race.name },
    { label: 'Location', value: race.location },
    { label: 'Date', value: race.date ? race.date.split('T')[0] : '' },
    { label: 'Ski', value: race.ski_id ? (skiMap[race.ski_id] ? `#${skiMap[race.ski_id]}` : 'Ski no longer part of fleet') : 'Ski no longer part of fleet' },
    { label: 'Technique', value: race.technique },
    { label: 'Performance', value: race.performance },
    { label: 'Temperature', value: race.temperature },
    { label: 'Time of Day', value: race.time_of_day },
    { label: 'Snow Conditions', value: race.snow_conditions },
    { label: 'Humidity', value: race.humidity != null ? race.humidity + '%' : '' },
    { label: 'Distance', value: race.distance },
    { label: 'Comments', value: race.comments },
  ];
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ bgcolor: theme.palette.background.paper, color: theme.palette.text.primary }}>Race Details</DialogTitle>
      <DialogContent sx={{ bgcolor: theme.palette.background.paper, color: theme.palette.text.primary }}>
        <TableContainer component={Paper} sx={{ my: 2, borderRadius: 2, boxShadow: 1, bgcolor: theme.palette.background.paper }}>
          <Table size="small" sx={{ bgcolor: theme.palette.background.paper }}>
            <TableBody>
              {detailRows.map((row, i) => (
                <TableRow key={row.label} sx={{ background: i % 2 === 0 ? theme.palette.action.hover : theme.palette.background.paper }}>
                  <TableCell sx={{ fontWeight: 600, width: '35%', color: theme.palette.text.primary }}>{row.label}</TableCell>
                  <TableCell sx={{ wordBreak: 'break-word', color: theme.palette.text.primary }}>{row.value}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions sx={{ bgcolor: theme.palette.background.paper }}>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
} 